import { makeStyles, Theme } from '@material-ui/core/styles';
import { designTokens } from '../../theming/design-tokens';

const { spacing } = designTokens;

const styles = makeStyles((theme: Theme) => ({
  barStyle: {
    display: 'flex',
    padding: `${spacing.sm} 0 ${spacing.lg} 0`,
  },
  iconDiv: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    paddingLeft: spacing.md,
  },
  whiteSpace: { flex: 1 },
  buttonStyle: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
  },
  massUpdateButton: {
    marginRight: spacing.sm,
  },
}));

export default styles;
